import { render, staticRenderFns } from "./outboundReviewListRecord.vue?vue&type=template&id=313b4e92&scoped=true"
import script from "./outboundReviewListRecord.vue?vue&type=script&lang=js"
export * from "./outboundReviewListRecord.vue?vue&type=script&lang=js"
import style0 from "./outboundReviewListRecord.vue?vue&type=style&index=0&id=313b4e92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313b4e92",
  null
  
)

export default component.exports